import React, { useState, useEffect } from "react";
import TicketDetails from "./TicketDetails";
import service from "../apiSection/service";
import { getAuditSummary } from "../apiSection/apiUrlConstent";
import { dateFormatter } from "../Utils/dateFormatter";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { ShowAlert } from "../Common/Components/Alert";
import IntellectDetails from "./IntellectDetails";

const obj = {
  1: "Created by",
  2: "Resolved by",
  3: "Closed by",
  4: "Assigned to",
  5: "Overdue",
  7: "Assign to Intellect by",
  8: "Reopen by",
  9: "Resolved by Intellect"
};

const useStyles = makeStyles(() => ({
  body: {
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "white",
  },
  heading: {
    display: "flex",
    gap: "20px",
    marginBottom: "20px",
    borderBottom: "1px solid #e0e0e0",
    paddingBottom: "10px",
    cursor: "pointer",
  },
  title: { fontSize: "14px", color: "#5f6368" },
  font: { fontWeight: "700" },
  noHistory: {
    textAlign: "center",
    paddingTop: "5rem",
    fontSize: "30px",
    fontWeight: "600",
  },
  tabStyle: {
    fontWeight: "600",
    color: "#ffd700",
    borderBottom: "2px solid #ffd700",
    paddingBottom: "10px",
  },
  color: { color: "#666" },
  align: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  alignColumn: { display: "flex", flexDirection: "column", gap: "10px" },
}));

function TicketHistory({ rowData, userData, handleClose }) {
  console.log("ticketdetails", rowData);
  const [tab, setTab] = useState("Ticket Details");
  const [auditSummary, setAuditSummay] = useState([]);
  const [hasIntellect, setHasIntellect] = useState(false);
  const classes = useStyles();
  let colorCounter = 0;

  const checkForIntellect = (list) => {
    return list.find((value) => value?.status === 7) !== undefined;
  };

  useEffect(() => {
    const postData = {
      search_string: rowData?.tckt_id,
      page: 1,
      per_page: 20,
      start_date: "",
      end_date: "",
    };
    service
      .create(getAuditSummary, postData)
      .then((res) => {
        const list = res?.data?.result?.list || [];
        setAuditSummay(list);
        res?.data?.result?.list.find((value) => value?.status == 4);
        setHasIntellect(checkForIntellect(list));
        console.log(hasIntellect, "sam");
      })
      .catch((error) => {
        ShowAlert({
          icon: "error",
          text: error.message ? error.message : "Something went wrong",
        });
      });
  }, [rowData?.tckt_id]);
  console.log("summary", auditSummary);
  return (
    <div className={classes.dody}>
      <div className={classes.heading}>
        <span
          className={
            tab === "Ticket Details" ? classes.tabStyle : classes.color
          }
          onClick={() => setTab("Ticket Details")}
        >
          Details
        </span>
        <span
          className={
            tab === "Ticket History" ? classes.tabStyle : classes.color
          }
          onClick={() => setTab("Ticket History")}
        >
          Summary
        </span>
        {/* {(rowData?.tckt_status === 2 || rowData?.tckt_status === 3) && */}
          {/* (hasIntellect ? ( */}
            <span
              className={
                tab === "Intellect Details" ? classes.tabStyle : classes.color
              }
              onClick={() => setTab("Intellect Details")}
            >
              Comments
            </span>
          {/* ) : null)} */}
        
      </div>
      {tab === "Ticket History" ? (
        auditSummary?.length > 0 ? (
          <div className={classes.alignColumn}>
            {auditSummary?.map((value, index) => (
              <>
                <Box
                  key={value.id}
                  sx={{
                    // display: "flex",
                    // justifyContent: "space-between",
                    // alignItems: "center",
                    padding: "16px",
                    borderRadius: "8px",
                    backgroundColor:
                      ++colorCounter % 2 === 0 ? "#e7f6fc" : "#f1f3f4", // #e7f6fc
                  }}
                >
                  <div className={classes.align}>
                    {value?.status == 1 ? (
                      <div>
                        <div className={classes.font}>{obj[value?.status]}</div>
                        {value?.created_name && (
                          <div>
                            <div className={classes.title}>
                              {value?.created_name ? value?.created_name : ""}{" "}
                              on {dateFormatter(value?.created_on)}
                            </div>
                          </div>
                        )}
                      </div>
                    ) : value.status == 2 ? (
                      <div>
                        <div className={classes.font}>{obj[value?.status]}</div>
                        <div className={classes.title}>

                          {/* {auditSummary.findLastIndex(
                            (data) => data?.status === 7
                          ) !== -1 &&
                          auditSummary.findLastIndex(
                            (data) => data?.status === 7
                          ) < index
                            ? "Intellect"
                            : value?.created_name}{" "} */}
                            {value?.created_name} on{" "}
                          on {dateFormatter(value?.created_on)}
                        </div>
                      </div>
                    ) : value.status == 3 ? (
                      <div>
                        <div className={classes.font}>{obj[value?.status]}</div>
                        <div className={classes.title}>
                          {value?.created_name} on{" "}
                          {dateFormatter(value?.created_on)}
                        </div>
                      </div>
                    ) : value.status == 4 ? (
                      <div>
                        <div className={classes.font}>Reassigned to</div>
                        <div className={classes.title}>
                          {value?.reassigned_name} on{" "}
                          {dateFormatter(value?.created_on)}
                        </div>
                      </div>
                    ) : value.status == 5 ? (
                      <div>
                        <div className={classes.font}>{obj[value?.status]}</div>
                        <div className={classes.title}>
                          {dateFormatter(value?.created_on)}
                        </div>
                      </div>
                    ) : value.status == 7 ? (
                      <div>
                        <div className={classes.font}>{obj[value?.status]}</div>
                        <div className={classes.title}>
                          {value?.reassigned_name} on{" "}
                          {dateFormatter(value?.created_on)}
                        </div>
                      </div>
                    ) : value.status == 8 ? (
                      <div>
                        <div className={classes.font}>{obj[value?.status]}</div>
                        <div className={classes.title}>
                          {value?.modified_name} {value?.name} on{" "}
                          {dateFormatter(value?.created_on)}
                        </div>
                      </div>
                    ) : value.status == 10 ? (
                      <div>
                        <div className={classes.font}>Reopen-Intellect</div>
                        <div className={classes.title}>
                          {value?.reassigned_name} on{" "}
                          {dateFormatter(value?.created_on)}
                        </div>
                      </div>
                    ) :value.status == 11 ? (
                      <div>
                        <div className={classes.font}>Resolved by Intellect</div>
                        <div className={classes.title}>
                          {dateFormatter(value?.created_on)}
                        </div>
                      </div> 
                      ) :null}
                  </div>
                </Box>
                {
                  value.status===11 &&  <div style={{backgroundColor:
                    ++colorCounter % 2 === 0 ? "#e7f6fc" : "#f1f3f4",  padding: "16px",
                    borderRadius: "8px",}}>
                  <div className={classes.font}>Assigned to</div>
                  <div className={classes.title}>
                  {value?.reassigned_name} on{" "}
                    {dateFormatter(value?.created_on)}
                  </div>
                </div>
                }
                {value.status == 1 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "16px",
                      borderRadius: "8px",
                      backgroundColor:
                        ++colorCounter % 2 === 0 ? "#e7f6fc" : "#f1f3f4", // #e7f6fc
                    }}
                  >
                    <div>
                      <div className={classes.font}>Assigned to</div>
                      {value?.created_name && (
                        <div>
                          <div className={classes.title}>
                            {value?.reassigned_name
                              ? value?.reassigned_name
                              : ""}{" "}
                            on {dateFormatter(value?.created_on)}
                          </div>
                        </div>
                      )}
                    </div>
                  </Box>
                )}
                {value.status == 2 &&
                  auditSummary.findLastIndex((data) => data?.status === 7) !==
                    -1 &&
                  auditSummary.findLastIndex((data) => data?.status === 7) <
                    index && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "16px",
                        borderRadius: "8px",
                        backgroundColor:
                          ++colorCounter % 2 === 0 ? "#e7f6fc" : "#f1f3f4", // #e7f6fc
                      }}
                    >
                      <div>
                        <div className={classes.font}>Close Request</div>
                        {value?.created_name && (
                          <div>
                            <div className={classes.title}>
                              {value?.reassigned_name
                                ? value?.reassigned_name
                                : ""}{" "}
                              on {dateFormatter(value?.created_on)}
                            </div>
                          </div>
                        )}
                      </div>
                    </Box>
                  )}
                {value.status == 8 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "16px",
                      borderRadius: "8px",
                      backgroundColor:
                        ++colorCounter % 2 === 0 ? "#e7f6fc" : "#f1f3f4", // #e7f6fc
                    }}
                  >
                    <div>
                      <div className={classes.font}>Assigned to</div>
                      {value?.created_name && (
                        <div>
                          <div className={classes.title}>
                            {value?.reassigned_name
                              ? value?.reassigned_name
                              : ""}{" "}
                            on {dateFormatter(value?.created_on)}
                          </div>
                        </div>
                      )}
                    </div>
                  </Box>
                )}
              </>
            ))}
          </div>
        ) : (
          <div className={classes.noHistory}>No History Found</div>
        )
      ) : tab === "Ticket Details" ? (
        <TicketDetails
          rowData={rowData}
          userData={userData}
          handleClose={handleClose}
        />
      ) : tab === "Intellect Details" ? (
        <IntellectDetails rowData={rowData} />
      ) : null}
    </div>
  );
}

export default TicketHistory;
